import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx'
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { useParams } from 'react-router-dom';
import { Formatter, pegarEmpresaSelecionada, Periodo, Tipo } from "./Relatorio";
import { ICredito, IDebito, IDetalhesMatch, } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';

interface Column {
  id: string;
  label: string;
  width?: string;
  align?: "center" | "left" | "right";
}

function RelatorioMatch() {

  const { id } = useParams<{ id: string }>();
  const { classes } = useLayout();
  const [carregado, setCarregado] = useState<boolean>(false);
  const [detalhesMatch, setDetalhesMatch] = useState<IDetalhesMatch>();
  const [dataInicial, setDataInicial] = useState<Date>();
  const [dataFinal, setDataFinal] = useState<Date>();
  const [dadosExportar, setDadosExportar] = useState<any>();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Clientes',
      path: '/relatorioSelecionarCliente',
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false
    },
    {
      title: 'Relatório',
      path: `/relatorio/${id}`,
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: true
    }
  ]
  const columns: Column[] = [
    { id: 'dataString', label: 'Data', width: '14%', align: 'center' },
    { id: 'historico', label: 'Histórico', width: '50%', align: 'center' },
    { id: 'valor', label: 'Valor', width: '10%', align: 'left' },
    { id: 'conta', label: 'Conta Empresa', width: '24%', align: 'center' },
    { id: 'simbolo', label: 'Símbolo', width: '2%', align: 'center' }
  ];
  const useStyles = makeStyles({
    root: {
      width: '100%'
    },
    container: {
      maxHeight: 600
    },
    cell: {
      fontSize: '0.750em',
      padding: '0.250em',
      height: '42px'
    },
    simbolo: {
      '& *': {
        color: '#008F4C',
        fontSize: '2rem'
      }
    }
  });
  const styles = useStyles();
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  useEffect(() => {
    function preCarregar() {
      try {
        const titulo = document.querySelectorAll("h1")[0];
        const estiloTitulo = titulo.getAttribute('style') + 'font-size: 16px';
        const pageTitle = document.querySelectorAll(".page-title")[0];
        const estiloPageTitle = (pageTitle.getAttribute('style') ?? "") + 'margin-right: 0 !important';

        titulo.setAttribute('style', estiloTitulo);
        pageTitle.setAttribute('style', estiloPageTitle);
      } catch {
        setTimeout(() => {
          preCarregar();
        }, 50);
      }
    }

    const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
    const dataInicial = JSON.parse(jsonDataInicial) as Date | undefined;
    const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
    const dataFinal = JSON.parse(jsonDataFinal) as Date | undefined;

    setDataInicial(dataInicial);
    setDataFinal(dataFinal);

    preCarregar();
  }, [])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
  }, [dataInicial])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
  }, [dataFinal])

  useEffect(() => {
    async function preCarregar() {
      setCarregado(false);

      const empresa = pegarEmpresaSelecionada();
      const jsonContaEmpresa = localStorage.getItem(`${Tipo.ContaEmpresa}`) as "";
      const contaEmpresa = JSON.parse(jsonContaEmpresa) as number | undefined;

      if (empresa && empresa.id !== 0 && dataInicial && dataFinal) {
        await RelatoriosService.detalhesMatches(empresa.id, dataInicial, dataFinal, x => {
          let creditos = x.creditos.filter(p => !contaEmpresa || p.conta + '' === contaEmpresa.toString());
          let chaves = creditos.map(p => p.chaveVinculoMatch);
          let debitos = x.debitos.filter(p => chaves.includes(p.chaveVinculoMatch));
          setDetalhesMatch({ creditos, debitos });
          setDadosExportar([...debitos.map(d => ({
            'Tipo': 'DÉBITO',
            'Data': d.dataString,
            'Histórico': d.historico,
            'Valor': d.valor,
            'Conta Empresa': d.conta
          })), ...creditos.map(c => ({
            'Tipo': 'CRÉDITO',
            'Data': c.dataString,
            'Histórico': c.historico,
            'Valor': c.valor,
            'Conta Empresa': c.conta
          }))])
        });
      }

      setCarregado(true);
    }

    setTimeout(() => {
      preCarregar();
    }, 1000);
  }, [id, dataInicial, dataFinal])

  function handleChangePage(event: unknown, newPage: number) {
    setPage(newPage);
  };

  function handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
    setDataInicial(dataInicial);
    setDataFinal(dataFinal);
  }

  return <>
    <PageTitle pageBack={`/relatorio/${id}`} breadcrumbs={breadCrumbs}>{localStorage.getItem(`${Tipo.Match}`)}</PageTitle>
    <label style={{ color: '#525252', fontWeight: 700, fontSize: '20px', marginBottom: '10px' }}>{dataInicial && dataFinal ? carregado ? detalhesMatch ? `Matchs de Conciliações encontrados (${detalhesMatch.creditos.length})` : 'Não foi encontrado nenhum Match de Conciliação para ser exibido' : 'Carregando...' : 'Preencha o campo Período e clique em buscar para carregar os dados'}</label>
    <div className='toolbar' id='kt_toolbar' style={{ padding: ' 0 10px' }}>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ padding: '0' }}>
        <DefaultTitle />
        <Periodo dadosExportar={dadosExportar} dataInicio={dataInicial} dataFim={dataFinal} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
      </div>
    </div>

    {
      dataInicial && dataFinal && carregado && detalhesMatch &&
      <>
        <div className="col-md-12" style={{ display: 'flex' }}>
          <div className="col-md-6" style={{ marginRight: '5px' }}>
            <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Lançamento a débito</label>
            <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3' }}>
              <TableContainer className={styles.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow style={{ outline: '1px solid #A3A3A3' }} >
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} className={styles.cell} align={column.align} style={{ minWidth: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: '#ffffff' }} >
                            {column.label}
                          </TableCell>)
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      detalhesMatch.debitos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                        <TableRow hover role="checkbox" tabIndex={-1} key={index} style={{ outline: '1px solid #A3A3A3' }}>
                          {
                            columns.map((column, index) =>
                              <TableCell key={index} className={styles.cell} align={column.align} style={{ width: column.width }}>
                                {
                                  column.id === 'simbolo' ?
                                    <div className={styles.simbolo} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.simbolo) }} />
                                    :
                                    <label style={{ color: column.id === 'contaEmpresa' ? '#008F4C' : 'black' }}>
                                      {
                                        column.id === "valor" ?
                                          Formatter.format(row['valor'])
                                          :
                                          row[column.id as keyof IDebito]
                                      }
                                    </label>
                                }
                              </TableCell>)
                          }
                        </TableRow>)
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>

          <div className="col-md-6" style={{ marginLeft: '5px' }}>
            <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Lançamento a crédito</label>
            <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3' }}>
              <TableContainer className={styles.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow style={{ outline: '1px solid #A3A3A3' }}>
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} className={styles.cell} align={column.align} style={{ width: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: '#ffffff' }} >
                            {column.label}
                          </TableCell>)
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      detalhesMatch.creditos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                        <TableRow hover role="checkbox" tabIndex={-1} key={index} style={{ outline: '1px solid #A3A3A3' }}>
                          {
                            columns.map((column, index) =>
                              <TableCell key={index} className={styles.cell} align={column.align}>
                                {
                                  column.id === 'simbolo' ?
                                    <div className={styles.simbolo} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.simbolo) }} />
                                    :
                                    <label style={{ color: column.id === 'contaEmpresa' ? '#EB1F44' : 'black' }}>
                                      {
                                        column.id === "valor" ?
                                          Formatter.format(row['valor'])
                                          :
                                          row[column.id as keyof ICredito]
                                      }
                                    </label>
                                }
                              </TableCell>)
                          }
                        </TableRow>)
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </div>

        <TablePagination rowsPerPageOptions={[]} component="div" count={detalhesMatch.creditos.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
      </>
    }
  </>
};

export default RelatorioMatch;